import {useDebugValue} from 'react';

import {undef, DEFAULT_SUBMIT_ACTION_TYPE} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    actionType: DEFAULT_SUBMIT_ACTION_TYPE,
    iconName: 'search',
    isPrimaryAction: true,
    showIcon: undef
};

function useSubmitOptions(props) {
    const {
        submitOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useSubmitOptions};
